import { Chip } from "@mui/material";
import React from "react";
import RatingMUI from "../../../layouts/RatingMUI";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: "50px",
};

const DiversityInclusionKPI = ({ avgUtil, maxUtil, minUtil }) => {
  return (
    <>
      <RatingMUI value={5} />
      <p className="card-value">Diversity Inclusion</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max" sx={chipStyle} />
          <p className="m-1 p-0">{maxUtil}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min" sx={chipStyle} />
          <p className="m-1 p-0">{minUtil}</p>
        </div>
      </div>
    </>
  );
};

export default DiversityInclusionKPI;
